import React from "react";

function Home (){
    return <h1>Welcome to eTransport site</h1>
}

export default Home;